import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { DownloadService } from '../../services/download.service';
import { ExportService } from '../../services/export.service';
import { PopupService } from '../../services/popup.service';
import { FilterValues } from './filter-values';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss'],
})
export class DownloadComponent implements OnInit {
    agree = false;
    today: number = Date.now();
    filterValues: any;
    show: boolean = false;
    isMeasurementMode: boolean = false;
    isNetCDF: boolean = false;
    isFromUrl: boolean = false;

    constructor(
        private exportService: ExportService,
        private dialogService: DialogService,
        private downloadService: DownloadService,
        private popupService: PopupService
    ) {
        this.downloadService.getFilterValue().subscribe((data) => {
            this.filterValues = data;
            this.isNetCDF = this.filterValues.downloadFileType == "downNetCdf" ? true : false;
            this.isFromUrl = this.filterValues.isFromUrl;
        });

        this.dialogService.dialogData$.subscribe((data) => {
            this.isMeasurementMode = data.measurementMode;
        });
    }

    ngOnInit(): void { }

    exportData() {
        this.show = true;
        if (this.filterValues.spatial == true) {
            this.exportService
                .exportSpatialSamples(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showFile(
                        result,
                        `MARIS_download _${Math.floor(Date.now() / 1000)}.zip`
                    );
                });
        } else if (this.filterValues.downloadFileType == "downCsv" && this.isFromUrl) {
            this.exportService
                .exportSamplescsv(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showcsvFile(
                        result,
                        this.filterValues.reference.toString() + ".csv"
                    );
                });
        }
        else if (this.filterValues.downloadFileType == "downCsv" && !this.isFromUrl) {
            this.exportService
                .exportSamples(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showFile(
                        result,
                        `MARIS_download _${Math.floor(Date.now() / 1000)}.zip`
                    );
                });
        }
        else if (this.filterValues.downloadFileType == "downNetCdf") {
            this.exportService
                .exportSamplesnetcdf(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.shownetcdfFile(
                        result,
                        this.filterValues.reference.toString() + ".nc"
                    );
                });

        }
        else {
            this.exportService
                .exportSamples(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showFile(
                        result,
                        `MARIS_download _${Math.floor(Date.now() / 1000)}.zip`
                    );
                });
        }

        this.popupService.setPopupStatus('reset');
    }

    private showFile(blob: any, filename: string) {
        let newBlob = new Blob([blob], { type: 'text/csv' });
        this.show = false;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        let data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    private shownetcdfFile(blob: any, filename: string) {
        let newBlob = new Blob([blob], { type: 'text/nc' });
        this.show = false;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        let data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    private showcsvFile(blob: any, filename: string) {
        let newBlob = new Blob([blob], { type: 'text/csv' });
        this.show = false;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        let data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    closeDialog() {
        this.dialogService.hideDialog();
    }
}
